import React, { useContext } from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

import Layout from '../../components/Layout'
import Heading from '../../components/Heading'
import colors from '../../styles/colors'
import withPermissions from '../../containers/withPermissions'
import reportsIcon from '../../images/reportsIcon.svg'
import patientsIcon from '../../images/patientsIcon.svg'
import downloadIcon from '../../images/downloadIcon.svg'
import unitsIcon from '../../images/office.svg'
import surveysIcon from '../../images/surveysIcon.svg'
import postDiagnosticIcon from '../../images/post-diagnostic-icon.svg'
import statsRedIcon from '../../images/statsRedIcon.svg'
import { permissions } from '../../utils/constants'
import { mediaMin } from '../../utils/media'
import { AppContext } from '../../containers/App'

const decorate = withPermissions

const Dashboard = ({ hasPermissions }) => {
  const user = useContext(AppContext)
  return (
    <Layout>
      <Heading title="Pulpit" />
      <Grid>
        {/* <Stats />
      <Stats />
      <Stats /> */}
        {/* Users are accessed from units now
      hasPermissions(permissions.userAccess) && (
        <NavTile>
          <Link to="/app/users">
            <img src={usersIcon} />
            Użytkownicy
          </Link>
        </NavTile>
      )*/}
        {hasPermissions(permissions.diagnostician) && user.unitId !== null && (
          <NavTile>
            <Link to="/app/patients">
              <img src={patientsIcon} alt="" aria-hidden="true" />
              Osoby diagnozowane
            </Link>
          </NavTile>
        )}
        {user.userLevel === 9 && (
          <NavTile>
            <Link to="/app/reports">
              <img src={reportsIcon} alt="" aria-hidden="true" />
              Lista raportów
            </Link>
          </NavTile>
        )}
        {hasPermissions(permissions.diagnosticiansManagement) &&
          user.unitId !== null && (
            <NavTile>
              <Link to="/app/surveys">
                <img src={surveysIcon} alt="" aria-hidden="true" />
                Ankiety
              </Link>
            </NavTile>
          )}
        {hasPermissions(permissions.diagnosticiansManagement) &&
          (user.unitId !== null || user.userLevel === 9) && (
            <NavTile>
              <Link to="/app/units">
                <img src={unitsIcon} alt="" aria-hidden="true" />
                {user.userLevel === 3 ? 'Diagności' : 'Jednostka'}
              </Link>
            </NavTile>
          )}
        {hasPermissions(permissions.diagnostician) && (
          <NavTile>
            <Link to="/app/post-diagnostic">
              <img src={postDiagnosticIcon} alt="" aria-hidden="true" />
              Materiały wspierające <br /> diagnozę i postdiagnostyczne
            </Link>
          </NavTile>
        )}

        {hasPermissions(permissions.diagnosticiansManagement) &&
          (user.unitId !== null || user.userLevel === 9) && (
            <NavTile>
              <Link to="/app/statistics">
                <img src={statsRedIcon} alt="" aria-hidden="true" />
                Statystyki
              </Link>
            </NavTile>
          )}
        <NavTile>
          <a href="/desktop/OZP-36-Setup.exe" download>
            <img src={downloadIcon} alt="" aria-hidden="true" />
            Pobierz aplikację
          </a>
        </NavTile>
        {/* <Events /> //TODO WHEN CALANDAR IS READY */}
      </Grid>
    </Layout>
  )
}

const Grid = styled.div`
  margin: 50px auto 0;
  width: 100%;
  display: grid;
  grid-gap: 33px;
  grid-template-columns: repeat(12, 1fr);
  grid-auto-rows: 90px;
  ${mediaMin.medium`width:80%`};
  ${mediaMin.large`width:70%`};
`

// const Stats = styled.div` // TODO FEATURE
//   background: ${ colors.monza };
//   &:nth-child(1) {
//     grid-area: 1 / 1 / 2 / 5;
//   }
//   &:nth-child(2) {
//     grid-area: 1 / 5 / 2 / 9;
//   }
//   &:nth-child(3) {
//     grid-area: 1 / 9 / 2/ 13;
//   }
// `

const NavTile = styled.div`
  display: flex;
  background: #fff;
  transition: 0.3s all;
  cursor: pointer;
  border: 1px solid ${colors.alabaster};

  &:hover {
    box-shadow: 3px 3px 6px 0 rgba(116, 129, 141, 0.3);
  }
  > a {
    text-decoration: none;
    flex: 1;
    font-size: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    color: ${colors.light_black};
  }

  &:nth-child(1) {
    grid-column: 2/12;
  }
  &:nth-child(2) {
    grid-column: 2 / 12;
  }
  &:nth-child(3) {
    grid-column: 2 / 12;
  }
  &:nth-child(4) {
    grid-column: 2 / 12;
  }
  &:nth-child(5) {
    grid-column: 2 / 12;
  }
  &:nth-child(6) {
    grid-column: 2 / 12;
  }

  ${mediaMin.medium`
  &:nth-child(1) {
    grid-column: 1 / 5;
  }
  &:nth-child(2) {
    grid-column: 5 / 9;
  }
  &:nth-child(3) {
    grid-column: 9 / 13;
  }
  &:nth-child(4) {
    grid-column: 1 / 5;
  }
  &:nth-child(5) {
    grid-column: 5 / 9;
  }
  &:nth-child(6) {
    grid-column: 9 / 13;
  }
`};
`

// const Events = styled.div` //TODO FEATURE
//   grid-area: 2/ 7 / 5/ 13;
// `

export default decorate(Dashboard)
